class BfMobileDrawerMenu extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;

    this.dataset.initialized = 'true';
    this._accordionHandler = this.onAccordionClick.bind(this);
    this._closeHandler = this.onCloseClick.bind(this);
    this._linkedRowHandler = this.onLinkedRowClick.bind(this);
    this._loadImagesHandler = this.loadImages.bind(this);
    this._queueImagesHandler = this.queueImageHydration.bind(this);
    this._drawerDetails = this.closest('details');
    this._drawerSummary = this._drawerDetails?.querySelector('summary');

    this.querySelectorAll('.accordion').forEach((item) => {
      item.addEventListener('click', this._accordionHandler);
    });

    this.querySelectorAll('[data-bf-row-link]').forEach((item) => {
      item.addEventListener('click', this._linkedRowHandler);
    });

    this.querySelectorAll('[data-bf-mobile-drawer-close]').forEach((button) => {
      button.addEventListener('click', this._closeHandler);
    });

    this._drawerSummary?.addEventListener('click', this._loadImagesHandler, { once: true });
    this._drawerDetails?.addEventListener('toggle', this._loadImagesHandler);

    if (this._drawerDetails?.open) {
      this.loadImages();
    } else if (document.readyState === 'complete') {
      this.queueImageHydration();
    } else {
      window.addEventListener('load', this._queueImagesHandler, { once: true });
    }
  }

  disconnectedCallback() {
    this.querySelectorAll('.accordion').forEach((item) => {
      item.removeEventListener('click', this._accordionHandler);
    });

    this.querySelectorAll('[data-bf-row-link]').forEach((item) => {
      item.removeEventListener('click', this._linkedRowHandler);
    });

    this.querySelectorAll('[data-bf-mobile-drawer-close]').forEach((button) => {
      button.removeEventListener('click', this._closeHandler);
    });

    this._drawerSummary?.removeEventListener('click', this._loadImagesHandler);
    this._drawerDetails?.removeEventListener('toggle', this._loadImagesHandler);
    window.removeEventListener('load', this._queueImagesHandler);
  }

  loadImages() {
    this.querySelectorAll('img[data-src]').forEach((image) => {
      image.src = image.dataset.src;
      image.removeAttribute('loading');
      image.removeAttribute('data-src');
    });
  }

  queueImageHydration() {
    if (document.visibilityState === 'hidden') return;

    window.setTimeout(() => {
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(() => this.loadImages(), { timeout: 2500 });
        return;
      }

      this.loadImages();
    }, 1800);
  }

  onAccordionClick(event) {
    const accordion = event.currentTarget;
    if (!(accordion instanceof HTMLElement)) return;

    accordion.classList.toggle('active');

    const panel = accordion.nextElementSibling;
    if (!(panel instanceof HTMLElement)) return;

    panel.style.display = panel.style.display === 'block' ? 'none' : 'block';
  }

  onLinkedRowClick(event) {
    const row = event.currentTarget;
    if (!(row instanceof HTMLElement)) return;

    if (event.target instanceof Element && event.target.closest('a, button')) return;

    const destination = row.dataset.bfRowLink;
    if (!destination) return;

    window.location.assign(destination);
  }

  onCloseClick(event) {
    event.preventDefault();
    event.stopPropagation();

    this.closest('header-drawer')?.close();
  }
}

if (!customElements.get('bf-mobile-drawer-menu')) {
  customElements.define('bf-mobile-drawer-menu', BfMobileDrawerMenu);
}
